import { t } from '../helpers/t-converter'

export const contractTypeList = (type: ContractType): string => ({
  contract: t('Договір'),
  additionalContract: t('Додатковий договір')
}[type])

export const contractTypeName: Record<ContractType, string> = {
  contract: t('Договір'),
  additionalContract: t('Додатковий договір')
}

export const contractTypes = [
  'contract',
  'additionalContract'
] as const

export type ContractType = typeof contractTypes[number]
